
import React from 'react';
import SettingsContent from './SettingsContent';
import { KeysToComponentMap } from './KeysToComponentMap';
import SubMenu from '../../menu/submenu';
import Stack from '@mui/material/Stack';



function SettingsContainer({ subMenuData, rootURL, label }) {
    return (
        <React.StrictMode >
            <Stack direction="row" spacing={2}>
                <SubMenu data={subMenuData} rootURL={rootURL} componentMap={KeysToComponentMap} label={label} />
                <div id={"content-container"} >
                    <SettingsContent subMenuData={subMenuData} rootURL={rootURL} componentMap={KeysToComponentMap} label={label} />
                </div>
            </Stack>
        </React.StrictMode>
    );

}

export default SettingsContainer;
